// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Inqh","inner":"Footer_inner__1qaPQ","nextIcon":"Footer_nextIcon__17pSS","innerLeft":"Footer_innerLeft__2FRsi"};